module.exports = __webpack_public_path__ + "img/discord-logo.85af7c9f.svg";